<div class="row mb-3">

  <div class="col-auto">
    <div class="d-flex flex-row">
      <div><b>{{poplatok.sumaUhradit | number:'.2-2':'sk'}} Eur</b></div>
      <div *ngIf="poplatok.cakajucaPlatba">&nbsp;<span class="small" i18n>(prebieha spracovanie platby)</span></div>
    </div>
    <div>{{poplatok.iban ?? '?IBAN?'}}, VS: {{poplatok.variabilnySymbol}}, SS: {{poplatok.specifickySymbol}}<span *ngIf="poplatok.konstatnySymbol">, KS: {{poplatok.konstatnySymbol}}</span></div>
    <div>{{poplatok.popis}}</div>
    <div>{{poplatok.oj}}, {{poplatok.akRok}}</div>
    <div *ngIf="poplatok.datumSplatnosti"><span i18n>Splatnosť</span>: {{poplatok.datumSplatnosti | date}}</div>
  </div>

  <div class="col-auto">
    <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
    <a *ngIf="!loading" (click)="download(poplatok)" i18n-title title="download payment info">
      <mat-icon>save_alt</mat-icon>
    </a>
    <a *ngIf="!loading && platobnaBrana" (click)="pay(poplatok)" i18n-title title="pay by card">
      <br><mat-icon>credit_card</mat-icon>
    </a>
  </div>

</div>
